import script from "./SwitcherSizes.vue?vue&type=script&lang=js"
export * from "./SwitcherSizes.vue?vue&type=script&lang=js"

import "./SwitcherSizes.vue?vue&type=style&index=0&id=2f24512e&lang=scss"

const __exports__ = script;

export default __exports__